import React, { useState } from "react";
import { Grid, Typography, TextField, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const ContactComponent = () => {
  const theme = useTheme();
  const sectionTitle = {
    fontFamily: "sectionTitleFont",
    color: "white",
    paddingTop: "10px",
    paddingBottom: "10px",
  };

  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [formMessage, setFormMessage] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const { name, subject, email, phone } = formData;
    if (name && subject && email && phone) {
      setSubmitted(true);
      setFormMessage(
        "Thank you for contacting us. We will get back to you shortly!"
      );
      // You can send the form data to your backend or perform any other action here
    } else {
      setFormMessage("Please fill in all fields.");
    }
  };

  return (
    <Grid
      className="contact-container-main-section"
      data-aos="fade-up"
      data-aos-duration="3000"
      container
      spacing={2}
      sx={{
        pl: "50px",
        pr: "50px",
        pb: "50px",
        pt: "250px",
        pb: "100px",
        backgroundImage: "url(/assets/contact.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Grid
        data-aos="fade-right"
        data-aos-duration="900"
        data-aos-offset="300"
        data-aos-delay="100"
        item
        xs={12}
        sm={8}
        sx={{ pb: "20px" }}
      >
        <Typography
          className="location-head"
          id="contactsection"
          style={sectionTitle}
          sx={{ fontFamily: "sectionTitleFont", color: "white!important" }}
        >
          CONTACT
        </Typography>
        <Typography
          className="location-sub"
          sx={{ fontFamily: "titleFont", color: "white!important" }}
        >
          LEARN MORE ABOUT ARABIAN HILLS ESTATE
        </Typography>
        <Typography
          className="discription-pera"
          sx={{ fontFamily: "bodyFont", color: "white!important" }}
        >
          We are happy to connect with you. Reach out to the right team so we
          can serve you better.
        </Typography>
      </Grid>
      <Grid
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-offset="300"
        data-aos-delay="200"
        item
        xs={12}
        sm={8}
        md={8}
        sx={{
          textAlign: "center",
          pt: "20px",
          color: "white",
          borderColor: "white",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid className="contact-row-ipad" container spacing={2}>
            <Grid item sx={8} xs={12} sm={5} className={"input-field"}>
              <TextField
                fullWidth
                label="Name"
                id="name"
                variant="outlined"
                InputProps={{
                  style: {
                    color: "white",
                    background: "rgba(255, 255, 255, 0.2)",
                    border: "solid",
                    borderWidth: "0px",
                    borderColor: "white",
                    borderRadius: "0",
                    "&:focus": { borderColor: "none", boxShadow: "none" },
                  },
                }}
                InputLabelProps={{
                  style: { color: "rgba(255, 255, 255, 0.5)" },
                }}
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                fullWidth
                label="Subject"
                id="subject"
                variant="outlined"
                InputProps={{
                  style: {
                    color: "white",
                    background: "rgba(255, 255, 255, 0.2)",
                    border: "solid",
                    borderWidth: "0px",
                    borderColor: "white",
                    borderRadius: "0",
                    "&:focus": { borderColor: "none", boxShadow: "none" },
                  },
                }}
                InputLabelProps={{
                  style: { color: "rgba(255, 255, 255, 0.5)" },
                }}
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                fullWidth
                label="Email Address"
                id="email"
                variant="outlined"
                InputProps={{
                  style: {
                    color: "white",
                    background: "rgba(255, 255, 255, 0.2)",
                    border: "solid",
                    borderWidth: "0px",
                    borderColor: "white",
                    borderRadius: "0",
                    "&:focus": { borderColor: "none", boxShadow: "none" },
                  },
                }}
                InputLabelProps={{
                  style: { color: "rgba(255, 255, 255, 0.5)" },
                }}
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                fullWidth
                label="Contact No"
                id="phone"
                variant="outlined"
                InputProps={{
                  style: {
                    color: "white",
                    background: "rgba(255, 255, 255, 0.2)",
                    border: "solid",
                    borderWidth: "0px",
                    borderColor: "white",
                    borderRadius: "0",
                    "&:focus": { borderColor: "none", boxShadow: "none" },
                  },
                }}
                InputLabelProps={{
                  style: { color: "rgba(255, 255, 255, 0.5)" },
                }}
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                className="customGridHeight"
                fullWidth
                label="Type your enquiries here.."
                id="message"
                variant="outlined"
                InputProps={{
                  style: {
                    color: "white",
                    background: "rgba(255, 255, 255, 0.2)",
                    border: "solid",
                    borderWidth: "0px",
                    borderRadius: "0",
                    borderColor: "white",
                    fontWeight: "200",
                    "&:focus": { borderColor: "none", boxShadow: "none" },
                    paddingTop: "40px",
                  },
                }}
                InputLabelProps={{
                  style: { color: "rgba(255, 255, 255, 0.5)" },
                }}
                name="message"
                value={formData.message}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "transparent",
                  color: "white",
                  background: "rgba(255, 255, 255, 0.2)",
                  border: "solid",
                  borderWidth: "0.5px",
                  borderColor: "white",
                  borderRadius: "0",
                  marginBottom: "30px",
                  "&:hover": { backgroundColor: "#fff", color: "black" },
                }}
              >
                Send Now
              </Button>
            </Grid>
          </Grid>
        </form>
        {submitted && (
          <Typography
            sx={{ color: "white", color: "#FF0000", textAlign: "left" }}
          >
            {formMessage}
          </Typography>
        )}
      </Grid>
      <Grid
        data-aos="fade-left"
        data-aos-duration="1000"
        data-aos-offset="300"
        data-aos-delay="200"
        item
        xs={4}
        className="customGridPadding"
      >
        <Grid
          container
          direction="column"
          spacing={4}
          className="contact-text-container"
        >
          <Grid item className="contact-text-container-2">
            <Typography
              className="contact-icons"
              sx={{
                fontFamily: "bodyFont",
                color: "white",
                mb: 2,
                maxWidth: "425px",
                className: "form-info-text",
                // Limit max width to 425px
              }}
            >
              <EmailOutlinedIcon
                className="icon-socails"
                sx={{ marginRight: 1, fontSize: "20px" }}
              />
              <span>info@deca-properties.com</span>
            </Typography>
            <Typography
              className="contact-icons"
              sx={{
                fontFamily: "bodyFont",
                color: "white",
                mb: 2,
                maxWidth: "425px",
                className: "form-info-text", // Limit max width to 425px
              }}
            >
              <PhoneOutlinedIcon
                className="icon-socails"
                sx={{ marginRight: 1, fontSize: "20px" }}
              />
              <span>+971-5686 86 786</span>
            </Typography>
            <Typography
              className="contact-icons"
              sx={{
                fontFamily: "bodyFont",
                color: "white",
                mb: 2,
                maxWidth: "425px",
                className: "form-info-text", // Limit max width to 425px
              }}
            >
              <LocationOnOutlinedIcon
                className="icon-socails"
                sx={{ marginRight: 1, fontSize: "20px" }}
              />
              <span>UTC B-14, Main Sheikh Zayed Road, Al Wasl, Dubai, UAE</span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ContactComponent;
